import { createRouter, createWebHistory } from "vue-router";
import DeviceDisplayShell from "./shells/DeviceDisplayShell";

const routes = [
    {
        path: "/devices",
        name: "home",
        component: DeviceDisplayShell,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});
export default router;
